import { Tag } from 'antd';
import moment from 'moment';
import * as echarts from 'echarts';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { objectOfObject } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const DottedBar = (props) => {

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    translationCache,
    currentTimeZone,
  } = props;

  const [option, setOption] = useState(() => getOption(selectedThemeing, graphprops));
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  function getOption(theme, graphpropsLocal) {
    let themeLocal = theme || 'lightTheme';
    let title = graphpropsLocal && graphpropsLocal.title ? graphpropsLocal.title : '';
    return {
      tooltip: {
        trigger: 'axis',
        formatter: '{b} <br/>{a}: {c} <br/> {a1} : {c1}',
        axisPointer: {
          type: 'shadow',
          animation: true,
        },
        textStyle: {
          fontSize: 16,
        },
      },
      legend: {
        data: ['line', 'bar'],
        textStyle: {
          color: themeLocal === 'lightTheme' ? 'black' : 'white',
        },
      },
      yAxis: {
        splitLine: { show: false },
        axisLabel: {},
        axisLine: {
          lineStyle: {
            color: themeLocal === 'lightTheme' ? 'black' : 'white',
          },
        },
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: themeLocal === 'lightTheme' ? 'black' : 'black',
            name: title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2,
            },
          },
        },
      },
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          backgroundColor: '#9a9191',
          textStyle: {
            color: themeLocal === 'lightTheme' ? 'black' : 'white',
          },
        },
        {
          type: 'inside',
          start: 0,
          end: 100,
        },
      ],
      xAxis: {
        axisLine: {
          lineStyle: {
            color: themeLocal === 'lightTheme' ? 'black' : 'white',
          },
        },
      },
      series: [],
    };
  }

  const getData = async () => {
    requestCheck.current = false;
    let theme = selectedThemeing;
    let optionLocal = cloneDeep(option);
    let json = [];
    let xaxisLabels = [];
    let lineData = [];
    let barData = [];
    let tagName = [];
    let series = [];
    let xAxis = {};
    let legend = [];
    let errorFlag = false;
    let noDataFlag = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = objectOfObject;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorFlag = true;
      } else if (json.length === 0) {
        noDataFlag = true;
      }
    } else {
      let queryTagName = '';
      let query1TagName = '';
      if (json && json.query && json.query1) {
        queryTagName = json.query && json.query[0] && json.query[0].Name ? json.query[0].Name : '';
        query1TagName =
          json.query1 && json.query1[0] && json.query1[0].Name ? json.query1[0].Name : '';
        tagName.push(queryTagName);
        tagName.push(query1TagName);

        lineData =
          json.query &&
          Array.isArray(json.query) &&
          json.query.map((item) => {
            let date =
              graphprops && graphprops.type === 'live'
                ? moment
                  .utc(item.DateTime)
                  .tz(currentTimeZone)
                  .format('DD/MM/YYYY HH:mm:ss')
                : moment
                  .utc(item.DateTime)
                  .tz(currentTimeZone)
                  .format('DD/MM/YYYY HH:mm:ss');

            xaxisLabels.push(date);
            return item.Value;
          });

        barData =
          json.query1 &&
          Array.isArray(json.query1) &&
          json.query1.map((item) => {
            return item.Value;
          });
      }

      xAxis = {
        data: xaxisLabels,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white',
          },
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white',
          },
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white',
        },
      };

      if (tagName && Array.isArray(tagName)) {
        tagName.forEach((item) => {
          legend.push({
            name: item,
            icon: 'roundRect',
            textStyle: {
              color: theme === 'lightTheme' ? 'black' : 'white',
              fontSize: 18,
              fontWeight: 'bold',
            },
          });
        });
      }

      series = [
        {
          name: queryTagName,
          type: 'line',
          smooth: true,
          showAllSymbol: true,
          symbol: 'emptyCircle',
          itemStyle: {
            normal: {
              color:
                graphprops.colors && graphprops.colors[0]
                  ? graphprops.colors[0]
                  : 'red',
            },
          },
          symbolSize: 15,
          data: lineData,
        },
        {
          name: query1TagName,
          type: 'bar',
          barWidth: 10,
          itemStyle: {
            barBorderRadius: 5,
            color:
              graphprops &&
                graphprops.colors &&
                graphprops.colors[1]
                ? graphprops.colors[1]
                : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#14c8d4' },
                  { offset: 1, color: '#43eec6' },
                ]),
          },
          data: barData,
        },
        {
          name: queryTagName,
          type: 'bar',
          barGap: '-100%',
          barWidth: 10,
          itemStyle: {
            color:
              graphprops &&
                graphprops.colors &&
                graphprops.colors[2]
                ? graphprops.colors[2]
                : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(20,200,212,0.5)' },
                  { offset: 0.2, color: 'rgba(20,200,212,0.2)' },
                  { offset: 1, color: 'rgba(20,200,212,0)' },
                ]),
          },
          z: -12,
          data: lineData,
        },
        {
          name: query1TagName,
          type: 'pictorialBar',
          symbol: 'rect',
          itemStyle: {
            color:
              graphprops &&
                graphprops.colors &&
                graphprops.colors[2]
                ? graphprops.colors[2]
                : '#0f375f',
          },
          symbolRepeat: true,
          symbolSize: [12, 4],
          symbolMargin: 1,
          z: -10,
          data: lineData,
        },
      ];

      let seriesData = await trendLabelTranslation(series, translationCache);
      legend = await trendLabelTranslation(legend, translationCache);

      optionLocal = getOption(theme, graphprops);
      optionLocal.series = seriesData;
      optionLocal.xAxis = xAxis;
      optionLocal.legend = {
        textStyle: { color: theme === 'lightTheme' ? 'black' : 'white' },
        data: [...legend],
      };

      setOption(optionLocal);
      setRefreshDateTime(moment());
    }

    setErrorInAPI(errorFlag);
    setNoDataInDB(noDataFlag);
  };

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);
  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: '90%', width: '100%' }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(DottedBar);
